<template>
    <div>
        <h3>ログイン</h3>
        <div>
            <p>
                貸し本棚のログインは、２種類の方法があります。
                ひとつはメールアドレスとパスワードでログインする方法、もう一つは、
                ユーザー自身がお使いのGoogleアカウントと連携してログインする方法です。
            </p>
            <h4>メールアドレスとパスワードでログイン</h4>
            <img src="/img/help/account/01.png" alt="ログイン" class="img-thumbnail mb-3">
            <p>
                ログイン画面で登録したメールアドレスとパスワードを入力してログインしてください。
                連続で複数回ログインに失敗すると、一定時間ログインできなくなります。
                パソコンやスマートフォンを共用しておらず、ご自身だけでお使いの場合は、
                アカウント情報をブラウザに保存することを推奨します。
            </p>
            <h4>連携ログインによる登録</h4>
            <img src="/img/help/account/02.png" alt="連携ログイン" class="img-thumbnail mb-3">
            <p>
                Googleのアカウントをお持ちの方は、それぞれのアカウントにログインした状態で、
                「Googleアカウントで登録」ボタンをクリックして登録してください。
            </p>
            <p>
                複数アカウントに同時にログインされている場合、いずれのアカウントを使用するか選択画面が表示されます。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>


<script>
export default {
    created() {
        this.useHead({
            title: "ログイン | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>